import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { UpdateGrowerCameraSettingsRequest } from '@/lib/api/grower-camera-settings-api'
import { growerCameraSettingsApi } from '@/lib/api/grower-camera-settings-api'
import { ApiError } from '@/lib/api/client'
import { m } from '@/lib/paraglide/messages'

export const growerCameraSettingsKeys = {
    all: ['grower-camera-settings'] as const,
}

export function useGrowerCameraSettings() {
    return useQuery({
        queryKey: growerCameraSettingsKeys.all,
        queryFn: async () => {
            const res = await growerCameraSettingsApi.get()
            return res.data ?? null
        },
    })
}

export function useUpdateGrowerCameraSettings() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: async (data: UpdateGrowerCameraSettingsRequest) => {
            const res = await growerCameraSettingsApi.update(data)
            return res.data
        },
        onSuccess: () => {
            void qc.invalidateQueries({
                queryKey: growerCameraSettingsKeys.all,
            })
            toast.success(m.grower_camera_settings_save_success())
        },
        // Giữ message của backend: nó nói rõ thiếu field nào, hoặc vì sao
        // địa chỉ phải là HTTPS — fallback chung chỉ dùng khi không có message.
        onError: (error) =>
            toast.error(
                error instanceof ApiError && error.message
                    ? error.message
                    : m.grower_camera_settings_save_error(),
            ),
    })
}
